import * as React from 'react';

import { observer } from 'mobx-react';

import { buildNumericDropdownOptions } from '~utils/DropDownUtils';

import { DropDown, IDropDownProps } from './DropDown';

export const DateMonth = observer((props: Omit<IDropDownProps, 'options'>) => {
    const birthDayDropdownOptions = buildNumericDropdownOptions(1, 12);
    const propsWithOptions = {
        ...props,
        options: birthDayDropdownOptions
    };

    return <DropDown {...propsWithOptions} />;
});
